module.exports = __webpack_public_path__ + "img/IMG_8155_L_Wood.b448ded9.jpg";